import React from 'react';
import { ProfileUrlData, useProfileUrl } from 'app/blocks/common/providers/ProfileUrlProvider';

export default C => props => <C {...props} {...useProfileUrl()} />;

export { ProfileUrlData };
